export const environment = {
  production: true,
  version: '0.0.121b',
  url: 'https://api.dev.autoactioncloud.com/',
  carletonVersion: 'v2.0',
  carletonAmortizationVersion: 'v1.1'
};
